module.exports = __webpack_public_path__ + "static/media/action-spinner.7126845d.png";